import React from 'react';
import { cn } from '@/lib/utils';
import { StepIndicator } from './StepIndicator';

interface StepWrapperProps {
  title?: React.ReactNode;
  description?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  hideProgress?: boolean;
}

export const StepWrapper = ({ title, description, children, className, hideProgress }: StepWrapperProps) => {
  return (
    <div className={cn("step-wrapper-container animate-fade-in-up", className)}>
      {!hideProgress && (
        <div className="mb-6 md:mb-8">
          <StepIndicator />
        </div>
      )}

      <div className="bg-white rounded-2xl shadow-sm border border-foreground/10 p-6 md:p-8">

        {(title || description) && (
          <div className="mb-8 pt-2 space-y-4 text-left max-w-4xl">
            {title && (
              <div className="pb-3 border-b border-gray-200">
                <h2 className="section-title">
                  {title}
                </h2>
              </div>
            )}
            {description && (
              <div className="text-muted-foreground text-lg leading-relaxed max-w-3xl space-y-3">
                {description}
              </div>
            )}
          </div>
        )}

        {children}
      </div>
    </div>
  );
};
